module.exports = __webpack_public_path__ + "img/emoji_39.edd5f65a.png";